import * as React from 'react';
import { vars, mixin, css, classNames } from '@src/services/theme';

// typing
interface Props {
    w?: number;
    h?: number;
}

// style
const style = css`
    position: relative;

    > div {
        &:first-child {
            position: absolute;
            width: 100%;
            height: 100%;
        }
        &:last-child {
            content: "";
            display: block;
            /* padding-bottom: 100%; */
        }
    }
`;

// component
export default class Box extends React.Component<Props> {
	render() {
		const { children, w = 1, h = 1 } = this.props;
		return (
			<div className={style}>
                <div>
                    {children}
                </div>
                <div style={{ paddingBottom: `${(h/w*100)}%` }} />
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/UI/Ratio.tsx